import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Hidden from '@material-ui/core/Hidden';
import MainAppBar from '../app-bar/main/MainAppBar';
import SecondaryAppBar from '../app-bar/secondary/SecondaryAppBar';

const styles = {
  root: {},
};

function Header(props) {
  return (
    <div id="appHeader" className={props.classes.root}>
      <MainAppBar
        isRightDrawerOpen={props.isRightDrawerOpen}
        toggleRightDrawer={props.toggleRightDrawer}
        openContactDialog={props.openContactDialog}
        openHelpDialog={props.openHelpDialog}
      />
      <Hidden smDown>
        <SecondaryAppBar />
      </Hidden>
    </div>
  );
}

export default withStyles(styles)(Header);
